import React, { useState, useMemo, useEffect } from "react";
import "./Wallet.css";
import Navigation from "./Navigation.js";
import Footer from "./Footer.js";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import axios from "axios";

function Wallet() {
  const [client, setClient] = useState({
    clientName: "",
    clientEmail: "",
    bvn: "",
  });
  const [error, setError] = useState(false);
  useEffect(() => {
    if (
      !/[0-9]+$/.test(client.bvn) ||
      !/^([\w]{3,})+\s+([\w\s]{3,})+$/i.test(client.clientName) ||
      !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(client.clientEmail)
    ) {
      setError(true);
    }
  }, [client]);
  const handleSubmit = (e) => {
    e.preventDefault();
    var axios = require("axios");
    // var data = JSON.stringify({
    //   email: client.clientEmail,
    //   is_permanent: true,
    //   bvn: client.bvn,
    //   firstname: client.clientName,
    // });

    // var config = {
    //   method: "POST",
    //   url: "https://api.flutterwave.com/v3/virtual-account-numbers",
    //   headers: {
    //     "Content-Type": "application/json",
    //     Authorization: `Bearer ${process.env.REACT_APP_PRIVATE_KEY}`,
    //   },
    //   data: data,
    // };

    // axios(config)
    //   .then(function (response) {
    //     console.log(JSON.stringify(response.data));
    //   })
    //   .catch(function (error) {
    //     console.log(error);
    //   });
    // var data = JSON.stringify({
    //   email: "developers@flutterwavego.com",
    //   is_permanent: true,
    //   bvn: "12345678901",
    //   tx_ref: "VA12",
    //   phonenumber: "08109328188",
    //   firstname: "Angela",
    //   lastname: "Ashley",
    //   narration: "Angela Ashley-Osuzoka",
    // });

    // var config = {
    //   method: "post",
    //   url: "https://api.flutterwave.com/v3/virtual-account-numbers",
    //   headers: {
    //     "Content-Type": "application/json",
    //     "Authorization":  `Bearer ${process.env.REACT_APP_PRIVATE_KEY}`,
    //     "Access-Control-Allow-Origin": "*",
    //     "Access-Control-Allow-Methods": "*, POST",
    //     // "Access-Control-Allow-Credentials": "true",
    //     "Access-Control-Allow-Headers": "Content-Type, x-requested-with",
    //   },
    //   data: data,
    // };
    // const sendRequest = async () => {
    //   try {
    //     const response = await axios.post(
    //       "https://api.flutterwave.com/v3/virtual-account-numbers",
    //       config
    //     );
    //     console.log(response);
    //   } catch (err) {
    //     console.error(err);
    //   }
    // };

    // // axios(config)
    // //   .then(function (response) {
    // //     console.log(JSON.stringify(response.data));
    // //   })
    // //   .catch(function (error) {
    // //     console.log(error);
    // //   });
    // sendRequest();
    // const Flutterwave = require("flutterwave-node-v3");
    // const flw = new Flutterwave(
    //   process.env.REACT_APP_PUBLIC_KEY,
    //   process.env.REACT_APP_PRIVATE_KEY
    // );
    // const details = {
    //   email: "developers@flutterwavego.com",
    // };
    // flw.VirtualAcct.create(details).then(console.log).catch(console.log);
  };
  function handleClientChange(e) {
    setClient({
      ...client,
      clientName: e.target.value,
    });
  }
  function handleEmail(e) {
    setClient({
      ...client,
      clientEmail: e.target.value,
    });
  }
  function handleBvn(e) {
    if (e.target.value.length <= 11) {
      setClient({
        ...client,
        bvn: e.target.value.replace(/\D+/g, ""),
      });
    }
  }

  return (
    <div className="wallet-container">
      <div className="wallet-header">
        <Navigation></Navigation>
      </div>
      <div className="wallet-content">
        <div>
          <div className="wallet-content-label">
            <h2>Wallet <small>(Not Working Yet)</small> </h2>{" "}
          </div>
          <Box
            component="form"
            sx={{
              "& .MuiTextField-root": { m: 1, width: "25ch" },
            }}
            noValidate
            autoComplete="off"
          >
            <div className="wallet-content-form">
              <TextField
                required
                id="standard-required"
                label="Full Name"
                error={
                  !/^([\w]{3,})+\s+([\w\s]{1,})+$/i.test(client.clientName)
                }
                placeholder="Enter Your Full Name"
                variant="standard"
                value={client.clientName}
                onChange={handleClientChange}
              />
              <TextField
                required
                error={!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(client.clientEmail)}
                id="standard-required"
                label="Email"
                placeholder="Enter Your Email"
                variant="standard"
                value={client.clientEmail}
                onChange={handleEmail}
              />
              <TextField
                error={!/[0-9]+$/.test(client.bvn)}
                required
                id="standard-required"
                label="11 Digit BVN"
                placeholder="Enter BVN"
                variant="standard"
                value={client.bvn}
                onChange={handleBvn}
              />

              <button
                onClick={handleSubmit}
                className="button"
                disabled={
                  client.clientName.length === 0 ||
                  !/^([\w]{3,})+\s+([\w\s]{1,})+$/i.test(client.clientName) ||
                  !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(client.clientEmail) ||
                  client.clientEmail.length === 0 ||
                  client.bvn.length < 11
                }
              >
                Create Wallet
              </button>
            </div>
          </Box>
        </div>
      </div>
      <div className="wallet-footer">
        <Footer></Footer>
      </div>
      <style jsx>{`
        .button {
          background: ${client.clientName.length === 0 ||
          !/^([\w]{3,})+\s+([\w\s]{1,})+$/i.test(client.clientName) ||
          !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(client.clientEmail) ||
          client.clientEmail.length === 0 ||
          client.bvn.length < 11
            ? "#808080"
            : "#dd8560"};
        }
      `}</style>
    </div>
  );
}

export default Wallet;
